import axios from "axios.js";
import { showSnackbar } from "./UiAction";

// Defines all states values
export const GET_MIS_HOLIDAYS_LIST = "GET_MIS_HOLIDAYS_LIST";
export const GET_MIS_SINGLE_HOLIDAYS_LIST = "GET_MIS_SINGLE_HOLIDAYS_LIST";
export const ADD_MIS_HOLIDAYS = "ADD_MIS_HOLIDAYS";


export const getMisHolidaysList = () => (dispatch) => { // get all holidays data from api call
  axios.get(`holiday/months/get`).then((res) => {
    dispatch({
      type: GET_MIS_HOLIDAYS_LIST,
      payload: res.data,
    });
  });
};

export const getsingleMisHolidaysList = (Id) => (dispatch) => { // get single holiday list for view holiday page api
  axios.get(`holiday/${Id}/get`).then((res) => {
    dispatch({
      type: GET_MIS_SINGLE_HOLIDAYS_LIST,
      payload: res.data,
    });
  });
};

export const addMisHolidays = (data) => (dispatch) => { // create holiday api call
  axios
    .post(`holiday/create`, data, {
      headers: {
        "content-type": "application/json",
      },
    })
    .then((response) => {
      dispatch(showSnackbar(response.data.message, 'top', "success"));
      dispatch({
        type: ADD_MIS_HOLIDAYS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

